import {Box} from "@mui/material";
import {useState} from "react";
import {Lightbox} from "yet-another-react-lightbox";
import {Inline} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";

function imageLink(asset: string) {
	return `/1080x1920/${asset}`;
}

export default function Brochure() {

	const [open, setOpen] = useState(false);
	const [index, setIndex] = useState(0);
	const breakpoints = [1080]

	const toggleOpen = (state: boolean) => () => setOpen(state);

	const slides = [
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x1920.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19202.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19203.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19204.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19205.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19206.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19207.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19208.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19209.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192010.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192011.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192012.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192013.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192014.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192015.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192016.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192017.jpg",},
		{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192018.jpg",}
	]
		.map(({asset, ...rest}) => {
			const width = 1080;
			const height = 1920;

			return {
				src: imageLink(asset),
				width,
				height,
				srcSet: breakpoints.map((breakpoint) => ({
					src: imageLink(asset),
					width: breakpoint,
					height: Math.round((height / width) * breakpoint),
				})),
				...rest,
			};
		});

	const updateIndex =
		(when: boolean) =>
			({index: current}: { index: number }) => {
				if (when === open) {
					setIndex(current);
				}
			};

	return (
		<Box

		>
			<Lightbox
				index={index}
				slides={slides}
				plugins={[Inline]}
				on={{
					view: updateIndex(false),
					click: toggleOpen(true),
				}}
				carousel={{
					padding: 0,
					spacing: 0,
					imageFit: "cover",
				}}
				inline={{
					style: {
						width: "100%",
						maxWidth: "900px",
						aspectRatio: "1080/1920",
						margin: "0 auto",
					},
				}}
			/>

			<Lightbox
				open={open}
				close={toggleOpen(false)}
				index={index}
				slides={slides}
				on={{view: updateIndex(true)}}
				animation={{fade: 0}}
				controller={{closeOnPullDown: true, closeOnBackdropClick: true}}
			/>

		</Box>
	);
}